import request from 'utils/request'
import tagNameFileTypeMap from '../utils/profilePageUtils'
import { logSentryEvent } from '../../../../../utils/sentry'

const SET_FILES = 'SET_FILES'

const setFiles = files => {
  return {
    type: SET_FILES,
    files
  }
}

const parseFiles = files => {
  const resultFileArr = files.map(file => {
    const fileName = file.original_file_name
    const fileType = tagNameFileTypeMap[file.tag_name]
    return { fileName, fileType }
  })
  return resultFileArr
}

// In-flight and short cache to avoid duplicate participant_files/me when Profile effect runs multiple times
let filesRequestInFlight = false
const FILES_CACHE_MS = 3000
let filesLastFetchedAt = 0

export const fetchFiles = (options = {}) => {
  const { forceRefresh = false } = options
  return (dispatch, getState) => {
    if (filesRequestInFlight) {
      return Promise.resolve()
    }
    const cacheFresh = Date.now() - filesLastFetchedAt < FILES_CACHE_MS
    if (!forceRefresh && cacheFresh) {
      return Promise.resolve()
    }
    filesRequestInFlight = true
    return dispatch(
      request({
        url: '/control/participant_files/me',
        hasLoader: true,
        success: payload => {
          logSentryEvent({
            message: 'File upload: fetch_success',
            tags: {
              flow: 'file-upload',
              'file.action': 'fetch_success'
            },
            contexts: {
              fileUpload: {
                moduleName: 'profile',
                endpoint: '/control/participant_files/me'
              }
            }
          })
          filesLastFetchedAt = Date.now()
          dispatch(setFiles(payload.participant_files))
        }
      })
    ).catch(error => {
      logSentryEvent({
        message: 'File upload: fetch_failed',
        level: 'error',
        tags: {
          flow: 'file-upload',
          'file.action': 'fetch_failed'
        },
        contexts: {
          fileUpload: {
            moduleName: 'profile',
            endpoint: '/control/participant_files/me'
          }
        },
        error
      })
      throw error
    }).finally(() => {
      filesRequestInFlight = false
    })
  }
}

export const uploadFile = (formData, successMessage, catchMessage) => {
  return dispatch => {
    const success = () => {
      logSentryEvent({
        message: 'File upload: upload_success',
        tags: {
          flow: 'file-upload',
          'file.action': 'upload_success'
        },
        contexts: {
          fileUpload: {
            moduleName: 'profile',
            endpoint: '/control/participant_files'
          }
        }
      })
      dispatch(fetchFiles({ forceRefresh: true }))
      return true
    }
    return dispatch(
      request({
        method: 'POST',
        url: '/control/participant_files',
        contentType: 'multipart/form-data',
        body: formData,
        success,
        successMessage,
        catchMessage
      })
    ).catch(error => {
      logSentryEvent({
        message: 'File upload: upload_failed',
        level: 'error',
        tags: {
          flow: 'file-upload',
          'file.action': 'upload_failed'
        },
        contexts: {
          fileUpload: {
            moduleName: 'profile',
            endpoint: '/control/participant_files'
          }
        },
        error
      })
      throw error
    })
  }
}

const files = (state = [], action) => {
  switch (action.type) {
    case SET_FILES: {
      return parseFiles(action.files)
    }
    default:
      return state
  }
}

export default files

export const fileActions = {
  uploadFile,
  fetchFiles
}
